import { Component } from 'react';
import ReactSelect from '../../../../components/ReactSelect';
import Loading from '../../../../components/Loading';
import MessageCustom from '../../../../components/MessageCustom';
import { checkEmail } from '../../query';
import Billing from './billing';

class UserInformation extends Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.previous = this.previous.bind(this);
        this.onChangeInfo = this.onChangeInfo.bind(this);
        this.onChangeSelect = this.onChangeSelect.bind(this);
        this.handleCheckboxChange = this.handleCheckboxChange.bind(this);
        this.onSubmitInfo = this.onSubmitInfo.bind(this);
        this.togglePassword = this.togglePassword.bind(this);
        this.isValidPassword = this.isValidPassword.bind(this);

        this.urlParams = new URLSearchParams(window.location.search);

        this.email = this.urlParams.get('email') || '';

        if (this.email) {
            this.email = atob(this.email);
        }

        this.state = {
            promotion_code: '',
            data: {
                name: '',
                email: this.email ?? '',
                organization: '',
                geo_location: '',
                password: '',
            },
            errors: {},
            step: 1,
            isAcceptCondition: false,
            showPassword: false,
            showPasswordMessage: false,
            loading: false,
            emailExists: false,
        };
    }

    togglePassword() {
        this.setState({
            showPassword: !this.state.showPassword,
        });
    }
    handleCheckboxChange(e) {
        this.setState({
            isAcceptCondition: e.target.checked,
        });
    }

    next() {
        this.setState({ step: this.state.step + 1 });
    }

    previous() {
        this.setState({ step: this.state.step - 1 });
    }

    async onSubmitInfo(e) {
        e.preventDefault();
        this.setState({ showPasswordMessage: true });
        const { google_discover_analytics, google_search_analytics, commerce, ai_tracking } =
            this.props?.products ?? {};
        const errors = {};
        if (!this.state.data.name) {
            errors['name'] = 'Name is required';
        }
        if (!this.state.data.email) {
            errors['email'] = 'Email is required';
        }

        if (!this.state.data.password) {
            errors['password'] = 'Password is required';
        }

        if (!google_discover_analytics && !google_search_analytics && !commerce && !ai_tracking) {
            errors['global'] = 'Please select at least one product';
        } else {
            delete errors['global'];
        }

        if (Object.keys(errors).length !== 0) {
            return this.setState({ errors });
        }

        this.setState({ loading: true, emailExists: false });
        try {
            const response = await checkEmail({ email: this.state.data.email });
            const data = await response.json();
            if (data?.status >= 400 || data?.message) {
                this.setState({ loading: false, emailExists: true });
                return;
            }
        } catch (err) {
            console.log('Error checking email:', err);
            this.setState({ loading: false });
            return;
        }

        this.setState({ loading: false });
        this.next();
    }

    onChangeInfo(e) {
        const field = e.target.name;
        const value = e.target.value;
        const newData = { ...this.state.data };
        newData[field] = value;
        const errors = { ...this.state.errors };
        delete errors?.[field];
        const nextState = { data: newData, errors };
        if (field === 'email') {
            nextState.emailExists = false;
        }
        this.setState(nextState);
        this.props.onChangeUserInfo(field, value);
    }

    onChangeSelect(option) {
        const newData = { ...this.state.data };
        newData['geo_location'] = option;
        this.setState({ data: newData });
        this.props.onChangeUserInfo('geo_location', option);
    }

    checkPassword(password) {
        return {
            minLength: password.length >= 8,
            hasUppercase: /[A-Z]/.test(password),
            hasLowercase: /[a-z]/.test(password),
            hasNumber: /\d/.test(password),
            hasSpecialChar: /[@$!%*?&]/.test(password),
        };
    }

    isValidPassword(password) {
        const checks = this.checkPassword(password);
        return (
            checks.minLength &&
            checks.hasUppercase &&
            checks.hasLowercase &&
            checks.hasNumber &&
            checks.hasSpecialChar
        );
    }

    generatePasswordValidationMessage(password) {
        const checks = this.checkPassword(password);

        return (
            <div className="password-validation-message">
                {this.isValidPassword(password) ? (
                    <div className="password-validation-message-item valid">
                        <i className="icon-check-icon" />
                        Great! your password is secure
                    </div>
                ) : (
                    <>
                        <div
                            className={`password-validation-message-item ${
                                checks.minLength ? 'valid' : ''
                            }`}
                        >
                            {checks.minLength ? (
                                <i className="icon-check-icon" />
                            ) : (
                                <i className="icon-x-close" />
                            )}
                            At least 8 characters
                        </div>
                        <div
                            className={`password-validation-message-item ${
                                checks.hasUppercase ? 'valid' : ''
                            }`}
                        >
                            {checks.hasUppercase ? (
                                <i className="icon-check-icon" />
                            ) : (
                                <i className="icon-x-close" />
                            )}
                            At least 1 uppercase letter
                        </div>
                        <div
                            className={`password-validation-message-item ${
                                checks.hasLowercase ? 'valid' : ''
                            }`}
                        >
                            {checks.hasLowercase ? (
                                <i className="icon-check-icon" />
                            ) : (
                                <i className="icon-x-close" />
                            )}
                            At least 1 lowercase letter
                        </div>
                        <div
                            className={`password-validation-message-item ${
                                checks.hasNumber ? 'valid' : ''
                            }`}
                        >
                            {checks.hasNumber ? (
                                <i className="icon-check-icon" />
                            ) : (
                                <i className="icon-x-close" />
                            )}
                            At least 1 number
                        </div>
                        <div
                            className={`password-validation-message-item ${
                                checks.hasSpecialChar ? 'valid' : ''
                            }`}
                        >
                            {checks.hasSpecialChar ? (
                                <i className="icon-check-icon" />
                            ) : (
                                <i className="icon-x-close" />
                            )}
                            At least 1 special character. Allowed special characters are: @$!%*?&
                        </div>
                    </>
                )}
            </div>
        );
    }

    render() {
        const optionList =
            this.props.geo_locations?.map((item) => ({
                value: item.geo,
                label: item.location,
            })) ?? [];
        optionList.unshift({ value: '', label: 'None' });

        const loginUrl = this.props.isFreeAiTemplate
            ? '/account/login/?next=/customers/change_plan/?template=free_one_month'
            : '/account/login/?next=/customers/change_plan/';
        return (
            <div className="custom-registration-body-step">
                <div className="custom-registration-body-step-header">
                    <span>3</span> Add personal & billing info
                </div>
                <div className="custom-registration-body-step-body">
                    <div className="custom-registration-user-information">
                        {this.state.step === 1 && (
                            <form
                                className="registration-container-info"
                                onSubmit={this.onSubmitInfo}
                            >
                                <div className="registration-container-info-form">
                                    <div className="custom-registration-user-information-first">
                                        <div className="text-field ">
                                            <label
                                                htmlFor="exampleInputEmail1"
                                                className="form-label"
                                            >
                                                Full Name <span>*</span>
                                            </label>
                                            <input
                                                name="name"
                                                className="form-control"
                                                placeholder="John Snow"
                                                aria-describedby="Your Name"
                                                onChange={this.onChangeInfo}
                                                value={this.state.data.name}
                                            />
                                            {this.state.errors['name'] && (
                                                <div className="error-message">
                                                    {this.state.errors['name']}
                                                </div>
                                            )}
                                        </div>
                                        <div className="text-field ">
                                            <label htmlFor="companies" className="form-label">
                                                Company Name (for invoice)
                                            </label>
                                            <input
                                                name="organization"
                                                className="form-control"
                                                placeholder="WallGuards, Inc."
                                                onChange={this.onChangeInfo}
                                                value={this.state.data.organization}
                                            />
                                        </div>
                                        <div className="text-field ">
                                            <label htmlFor="countries" className="form-label">
                                                Region (Optional)
                                            </label>
                                            <ReactSelect
                                                options={optionList}
                                                value={optionList.find(
                                                    (x) => x.value === this.state.data.geo_location,
                                                )}
                                                placeholder="Start Date"
                                                blurInputOnSelect={true}
                                                classname="mr-10"
                                                onChange={this.onChangeSelect}
                                                themeStyles={{ height: '45px' }}
                                                alwaysWhite
                                                controlStyles={{
                                                    boxShadow: 'none',
                                                    padding: '3px 3px',
                                                    fontSize: '13px',
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="text-field ">
                                        <label htmlFor="exampleInputEmail1" className="form-label">
                                            Email <span>*</span>
                                        </label>
                                        <input
                                            name="email"
                                            type="email"
                                            className="form-control"
                                            placeholder="john.snow@wallguardinc.com"
                                            onChange={this.onChangeInfo}
                                            value={this.state.data.email}
                                        />
                                        {this.state.errors['email'] && (
                                            <div className="error-message">
                                                {this.state.errors['email']}
                                            </div>
                                        )}
                                    </div>
                                    <div
                                        className="text-field "
                                        style={{
                                            gridColumn: 'span 2',
                                        }}
                                    >
                                        <label htmlFor="password" className="form-label">
                                            Password <span>*</span>
                                        </label>
                                        <div className="registration-password-container">
                                            <input
                                                name="password"
                                                type={this.state.showPassword ? 'text' : 'password'}
                                                className="form-control"
                                                placeholder="password"
                                                onChange={this.onChangeInfo}
                                                value={this.state.data.password}
                                                onFocus={() =>
                                                    this.setState({ showPasswordMessage: true })
                                                }
                                            />
                                            <button
                                                onClick={this.togglePassword}
                                                type="button"
                                                className={
                                                    this.state.showPassword ? 'reg-active-btn' : ''
                                                }
                                            >
                                                <i className="icon-Vector-4"></i>
                                            </button>
                                        </div>
                                        {this.state.showPasswordMessage &&
                                            this.generatePasswordValidationMessage(
                                                this.state.data.password,
                                            )}
                                        {this.state.errors['password'] && (
                                            <div className="error-message">
                                                {this.state.errors['password']}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                {this.state.errors['global'] && (
                                    <div className="error-message">
                                        {this.state.errors['global']}
                                    </div>
                                )}
                                {this.state.step === 1 && this.state.emailExists && (
                                    <MessageCustom
                                        message={
                                            <div className="custom-registration-login-error">
                                                An account with this email already exists.{' '}
                                                <a href={loginUrl}>Log in</a> to continue your
                                                purchase, or use a different email address.
                                            </div>
                                        }
                                        message_type="alert-danger"
                                    />
                                )}
                                <div className="w-100">
                                    <button
                                        className="registration-container-info-submit"
                                        type="submit"
                                        disabled={
                                            !this.isValidPassword(this.state.data.password) ||
                                            this.props.isSubmitDissabled ||
                                            this.state.loading
                                        }
                                    >
                                        {this.state.loading && <Loading onlyPreloader />}
                                        Continue
                                    </button>
                                    {this.props.isFreeAiTemplate ? (
                                        <div className="custom-registration-user-information-cancel-note">
                                            <i className="icon-check-icon" />
                                            Cancel anytime — no long-term commitments.
                                        </div>
                                    ) : (
                                        <div className="custom-registration-user-information-cancel-note">
                                            <span className="custom-registration-user-information-cancel-note-icon">
                                                🔒
                                            </span>
                                            Secure checkout. Your data is encrypted and safe with us.
                                            • Cancel at anytime
                                        </div>
                                    )}
                                </div>
                            </form>
                        )}
                        {this.state.step === 2 && (
                            <Billing
                                previous={this.previous}
                                onChangeInfo={this.onChangeInfo}
                                cardholder_name={this.state.data.cardholder_name}
                                email={this.state.data.email}
                                createRequestBody={this.props.createRequestBody}
                                lastPrice={this.props.lastPrice}
                                totalSavings={this.props.totalSavings}
                                isFreeAiTemplate={this.props.isFreeAiTemplate}
                            />
                        )}
                    </div>
                </div>
            </div>
        );
    }
}

export default UserInformation;
